var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTest2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 781.92 900.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M423.13 264.38h.26c39.63 7.36 67.65 25.44 67.65 46.58v125.29c.1.02.2.04.31.06 13.73 3.13 20.19 22.3 14.43 42.82-2.89 10.3-8.31 18.98-14.73 24.68v60.53c0 18.46-21.38 34.6-53.2 43.29-34.35 9.38-77.36 9.14-111.37-.93-30-8.88-49.92-24.53-49.92-42.35v-60.53c-6.42-5.7-11.84-14.38-14.73-24.68-5.76-20.52.7-39.69 14.43-42.82.1-.02.2-.04.31-.06V310.97c0-21.19 28.16-39.31 67.95-46.64 5.6-7.62 21.08-13.1 39.3-13.1s33.77 5.51 39.34 13.16z",
    fill: "#d30334",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M491.31 340.58c6.16 0 11.15 11.38 11.15 25.41s-4.99 25.41-11.15 25.41h-.27v-50.8h.27zM276.28 340.58c-6.16 0-11.15 11.38-11.15 25.41s4.99 25.41 11.15 25.41h.27v-50.8h-.27z",
    fill: "#6d6f7a",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#74042b",
    fillRule: "evenodd",
    d: "M498.28 438.41l9.29 20.48-32.21-2.47-3.69-16.15 15.39-4.38 11.22 2.52z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M482.33 509.65l-19.98-.43-6.74-14.59-2.21-13.53 9.1-4.2 19.83 32.75zm15.79-13.94l-31.95-28.02-3.04 6.18 24.25 32.59 10.75-10.75z",
    fill: "#eb6675",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M459.29 502.59c8.7 9.28 22.07 10.23 31.75 1.3 10.65-9.82 20.78-30.05 16.13-47.56-1.55-5.82-5.22-11.63-11.92-18.61l-.91 4.53c7.49 13.88 4.99 29.93-.08 40.3-7.37 15.07-15.86 25.15-34.97 20.04zM308.55 502.65c-8.7 9.28-22.07 10.23-31.75 1.3-10.65-9.82-20.78-30.05-16.13-47.56 1.55-5.82 5.22-11.63 11.92-18.61l.91 4.53c-7.49 13.88-4.99 29.92.08 40.3 7.37 15.07 15.86 25.15 34.97 20.04z",
    fill: "#6d6f7a",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M499.9 441.14c-2.1-1.38-3.88-2.62-4.64-3.4l-3.85-1.22 2.93 5.74c2.79 5.16 4.19 10.62 4.59 15.97l4.38.33 5.15.39c-.88-7.36-4.45-13.69-8.56-17.82z",
    fill: "#45454d",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M383.79 290.04c22.88 0 41.54-8.72 41.54-19.41s-18.66-19.41-41.54-19.41-41.54 8.72-41.54 19.41 18.66 19.41 41.54 19.41z",
    fill: "#eb6675",
    fillRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M421.19 263.55c40.76 6.99 69.85 25.28 69.85 46.75 0 27.49-47.7 49.78-106.54 49.78s-106.55-22.29-106.55-49.78c0-2.75.49-5.45 1.4-8.08l67.48 27.53 50.48 3.35 28.45-8.44 10.56-7.46 3.96-9.73-15.85-40.85-3.25-3.06zm-108.53 9.99l27.91-.1 6.34-9.73c-12.76 2.25-24.36 5.61-34.25 9.83z",
    fill: "#eb6675",
    fillRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#74042b",
    fillRule: "evenodd",
    d: "M425.42 491.72l-3.52-21.75 31.5 11.12 3.3 18.36-31.28-7.73zM318.39 416.94l-12.97-3.72-14.65 2.75-18.44 21.76 18.33 1.04 27.73-21.83z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#74042b",
    fillRule: "evenodd",
    d: "M269.31 438.41l-9.29 20.48 32.21-2.47 3.69-16.15-15.39-4.38-11.22 2.52z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M269.31 438.41l-9.29 20.48 8.84-.68c.72-8.13 3.34-15.18 7.46-21.38l-7.01 1.57z",
    fill: "#45454d",
    fillRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M445.44 421.19l16.12-7.92 23.34 22.79-12.63 5.82-26.83-20.7zm-11.89 11.79l30.03 20.46 4.32-8.78-27.5-20.28-6.85 8.6zM342.92 448.6l-8.93-14.13-28.38 17.67 5.8 11.4 31.51-14.95zm2.5 16.06l-32.89 12.89-1-9.74 31.53-13.63 2.37 10.48zM265.67 488.57l9.77 11.56 29.65-18.89-12.52-8.86-26.9 16.18zm-3.4-11.77l30.66-15.96.94 8.05-29.82 14.47-1.77-6.56z",
    fill: "#eb6675",
    fillRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M265.67 488.57l9.77 11.56 7.18-4.57-7.09-9.09-1.26-3.07-8.61 5.18zm4.29-15.77l2.62 6.42-8.54 4.14-1.77-6.56 7.69-4z",
    fill: "#babac1",
    fillRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M355.91 330.37l-20.35-9.16 13.22-40.14 16.92 7.03-9.79 42.27zm15 2.77l6.21-43.38-5.6-.59-8.62 42.82 8.01 1.15z",
    fill: "#74042b",
    fillRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M403.72 287.66l10.01-3.58 16.26 38.58-13.24 6.24-13.02-41.25zm-11.4 2.87l7.19 41.35 8.17-1.3L397.67 290l-5.35.52zM431.99 355.74l34.22-12.24v69.89c-8.98-1.19-18.51 3.33-26.43 11.63s0 .01 0 .01c-2.83 2.96-5.46 6.41-7.78 10.25v-79.54zm-28.62 4.49l14.62-2.62v96.47l-14.62 19.51V360.24zm14.62 171.33v79.87c-4.87 1.16-9.75 1.91-14.62 2.19v-94.24c3.79 5.82 8.83 10.3 14.62 12.17zm48.22-20.35v84.95c-11.48 6.05-22.88 10.42-34.22 13.58v-78.92c1.02-.43 2.05-.93 3.09-1.53l31.13-18.07z",
    fill: "#eb6675",
    fillRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M335.44 355.18l-34.22-12.24v69.89c12.19-1.61 25.39 7.29 34.22 21.89v-79.54zm9.06.25l8.72 2.47v254l-8.72-1.18V355.43zm-43.28 153.68v86.42c10.29 6.74 21.73 11.19 34.22 13.58v-109.7c-2.91 2.84-4.42 4.39-10.36 5.74-5.94 1.35-14.46 3.13-23.86 3.96z",
    fill: "#74042b",
    fillRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M423.39 264.38c39.63 7.36 67.65 25.44 67.65 46.58 0 27.67-48.02 50.11-107.25 50.11s-107.25-22.43-107.25-50.11c0-21.23 28.26-39.38 68.17-46.68",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M426.84 273.41c28.85 6.92 48.48 20.58 48.48 36.29 0 22.71-40.98 41.11-91.53 41.11s-91.53-18.41-91.53-41.11c0-15.7 19.59-29.34 48.39-36.27",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M438.97 304.08c.21.55 1.32 3.63 1.32 3.75-.42 14.41-25.55 26.03-56.5 26.03s-56.5-11.82-56.5-26.4",
    fill: "none",
    stroke: "#1a1a18",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M328.58 304.21c-.21.55-1.32 3.63-1.31 3.75.42 14.41 25.55 26.03 56.49 26.03s56.5-11.82 56.5-26.4",
    fill: "none",
    stroke: "#1a1a18",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M383.79 280.1c11.17 0 20.28-4.26 20.28-9.47s-9.11-9.47-20.28-9.47-20.28 4.26-20.28 9.47 9.11 9.47 20.28 9.47z",
    fill: "#000003",
    fillRule: "evenodd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M383.79 267.48c6.02 0 11.25 1.5 13.92 3.71-2.66 2.21-7.9 3.71-13.92 3.71s-11.25-1.5-13.92-3.71c2.66-2.21 7.9-3.71 13.92-3.71z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M491.04 564.35c0 27.67-48.02 50.11-107.25 50.11s-107.25-22.43-107.25-50.11",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M491.04 326.15c0 27.67-48.02 50.11-107.25 50.11s-107.25-22.43-107.25-50.11M491.05 351.18c0 13.92-12.14 26.51-31.75 35.59v27.2M276.55 527.14c2.58 15.26 20.57 28.54 34.08 34.78v-53.64",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M478.97 420.03c-3.33-3.63-8.39-5.74-10.8-6.29-16.99-3.87-36.54 13.58-43.67 38.98-6.34 22.59-.72 43.86 12.56 51.01 2.26 1.22 5.09 2.08 7.61 2.42M288.62 420.03c3.33-3.63 8.39-5.74 10.8-6.29 16.99-3.87 36.54 13.58 43.67 38.98 6.34 22.59.72 43.86-12.56 51.01-2.26 1.22-5.09 2.08-7.61 2.42M455.13 494.26c1.67 1.3 3.56 2.23 5.67 2.71 11.47 2.61 24.66-9.16 29.47-26.3 4.15-14.8.7-28.75-7.7-33.97M312.45 494.26c-1.67 1.3-3.56 2.23-5.67 2.71-11.47 2.61-24.66-9.16-29.47-26.3-4.15-14.8-.7-28.75 7.7-33.97",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M453.96 483.5c.98.63 2.05 1.08 3.21 1.35 8.13 1.85 17.5-6.5 20.91-18.66 3-10.7.4-20.77-5.81-24.31-7.06 5.63-13.1 14.84-16.21 25.93-1.52 5.41-2.19 10.73-2.1 15.69zM313.62 483.5c-.98.63-2.05 1.08-3.21 1.35-8.13 1.85-17.5-6.5-20.91-18.66-3-10.7-.4-20.77 5.81-24.31 7.06 5.63 13.1 14.84 16.21 25.93 1.52 5.41 2.19 10.73 2.1 15.69z",
    fill: "#000003",
    fillRule: "evenodd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5,
    d: "M468.75 466.13l19.86 9.45M298.83 466.13l-19.85 9.45M285.9 487.42l13.56-12.91M294.8 494.95l9.9-15.1M304.17 497.32l5.45-15.69M475.77 459.74l16.03 2.95M291.81 459.74l-16.03 2.95M475.2 452.2l16.23-.68M292.39 452.2l-16.23-.68M473.26 446.18l13.83-3.83M294.33 446.18l-13.83-3.83"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M455.11 475.49c.64.41 1.34.71 2.1.88 5.32 1.21 11.43-4.25 13.67-12.2 1.96-6.99.26-13.58-3.8-15.88-4.61 3.68-8.56 9.7-10.6 16.95-.99 3.54-1.43 7.01-1.37 10.25zM312.47 475.49c-.64.41-1.34.71-2.1.88-5.32 1.21-11.43-4.25-13.67-12.2-1.96-6.99-.26-13.58 3.8-15.88 4.61 3.68 8.56 9.7 10.6 16.95.99 3.54 1.43 7.01 1.37 10.25z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M380.74 599.04v-96.83c14.75-7.66 28.49-18.35 41.16-32.24M380.75 376.85v49.59c-12.15 11.78-23.69 19.75-37.54 27.8",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000003",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.79 461.14c1.83 0 3.32 1.44 3.32 3.31s-1.49 3.46-3.32 3.45c-1.83 0-3.32-1.59-3.32-3.45s1.48-3.31 3.32-3.3zM394.49 460.4c1.83-.25 3.32.96 3.32 2.79s-1.49 3.62-3.32 3.9c-1.83.28-3.32-1.09-3.32-2.94s1.48-3.5 3.32-3.75zM392.01 471.39c.92 1.46.37 3.57-1.22 4.66-1.59 1.09-3.61.67-4.53-.88-.92-1.55-.37-3.58 1.21-4.58 1.59-1 3.62-.66 4.53.81zM375.57 471.37c-.92 1.46-.37 3.57 1.22 4.65 1.59 1.09 3.61.67 4.53-.87.92-1.55.37-3.58-1.21-4.58-1.59-1-3.62-.66-4.53.8zM373.09 460.39c1.83.25 3.32 1.89 3.32 3.75s-1.48 3.22-3.32 2.94c-1.83-.28-3.32-2.06-3.32-3.89s1.48-3.04 3.32-2.79zM381.32 453.79c.92 1.61.37 3.64-1.21 4.48-1.59.84-3.62.13-4.53-1.54-.92-1.67-.37-3.61 1.22-4.39 1.59-.79 3.61-.16 4.53 1.45zM386.27 453.78c-.92 1.61-.37 3.65 1.21 4.49 1.59.84 3.62.12 4.53-1.55.92-1.67.37-3.6-1.22-4.39-1.59-.79-3.61-.16-4.53 1.45z"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M451.77 506.48c3.97.29 7.93.59 11.9.88-8.88-6.97-12.31-22.81-7.61-39.55 5.76-20.52 21.56-34.62 35.29-31.49 1.02.23 1.99.55 2.93.96-2.64-3.2-5.28-6.39-7.93-9.58-19.27 1.59-29.68 8.33-38.01 27.24-8.3 18.86-6.18 41.17 3.43 51.55zM316.08 506.54c-3.97.29-7.93.59-11.9.88 8.88-6.97 12.31-22.81 7.61-39.55-5.76-20.52-21.56-34.62-35.29-31.49-1.02.23-1.99.55-2.93.96 2.64-3.2 5.29-6.39 7.93-9.58 19.27 1.58 29.68 8.33 38.01 27.24 8.3 18.86 6.18 41.17-3.43 51.55z",
    fill: "#6d6f7a",
    fillRule: "evenodd"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M290.72 438.73c-4.66-2.49-9.56-3.41-14.22-2.35-1.02.23-1.99.55-2.93.96 2.64-3.2 5.29-6.39 7.93-9.58 7.04.58 12.9 1.85 17.9 4.14l-8.68 6.83zM456.11 496.17c-1.25-3.53-1.97-7.54-2.13-11.83l-.58-3.24-10.19-3.6c-.25 7.03.75 13.72 2.84 19.32l10.65 2.63-.59-3.28z",
    fill: "#45454d",
    fillRule: "evenodd"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M462.68 452.82c1.16-1.84 2.41-3.56 3.73-5.14l1.49-3.03-8.74-6.44c-2.27 2.22-4.34 4.84-6.27 7.95l9.78 6.66zm9.6-10.94l-9.1-7.02c4.09-2.89 8.81-4.78 14.41-5.95l7.32 7.14c-4.3.59-8.63 2.63-12.62 5.82z",
    fill: "#babac1",
    fillRule: "evenodd"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M485.7 428.48c-.26-.06-1.51-.44-1.78-.49-15.25-2.81-32.53 12.9-38.9 35.59-5.16 18.4-1.6 35.83 7.88 43.93",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4,
    d: "M496.95 438.71l-18.5-19.23"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M459.29 502.59c3.21 3.43 7.07 5.72 11.14 6.8l9.92.22c.56-.12 1.13-.27 1.69-.44l-4.29-7.09c-4.86 2.17-10.8 2.56-18.45.52zm38.67-6.73l.13-.18-7.39-6.48c-2.5 4.16-5.25 7.68-8.56 10.23l5.23 7.03 10.59-10.6z",
    fill: "#babac1",
    fillRule: "evenodd"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5,
    d: "M481.69 487.42l-13.56-12.91M472.79 494.95l-9.9-15.1M463.41 497.32l-5.44-15.69"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M491.35 436.32c-13.73-3.13-29.53 10.97-35.29 31.49-5.76 20.52.7 39.69 14.43 42.82 13.73 3.13 29.53-10.97 35.29-31.49 5.76-20.52-.7-39.69-14.43-42.82z",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M460.03 502.64c1.25.68 2.6 1.19 4.03 1.51 12.88 2.94 27.71-10.3 33.12-29.56 4.61-16.42.88-31.91-8.29-37.95M307.82 502.7c-1.25.68-2.6 1.19-4.03 1.51-12.88 2.94-27.71-10.3-33.12-29.56-4.61-16.42-.88-31.91 8.3-37.95",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4,
    d: "M470.49 510.63l-27.06-4.71"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M425.34 270.63c-5.43 16.7-28.94 19.33-42.22 19.42-14.24.09-38.36-4.84-40.17-20.26-2.14 4.69-4.29 9.37-6.43 14.06 11.56 15.97 29.98 18.54 45.95 18.64 15.4.1 39.32-3.51 48.09-17.37l-5.22-14.49z",
    fill: "#6d6f7a",
    fillRule: "evenodd"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M377.11 289.81c-1.68-.13-3.41-.33-5.18-.59l-.41-.04-2.51 12.45c2.11.29 4.22.49 6.32.62l1.78-12.44zm-11.97-1.94c-5.04-1.26-9.91-3.13-13.81-5.74l-2.55-1.06-3.77 11.46c5.41 4.07 11.52 6.52 17.82 7.97l2.87-12.4-.55-.23z",
    fill: "#45454d",
    fillRule: "evenodd"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M411.26 284.97c-2.14.96-4.4 1.75-6.71 2.4l-.84.3 3.73 11.81c3.88-1.04 7.63-2.38 11.04-4.09l-4.76-11.29-2.46.88zm-16.97 16.91a95.1 95.1 0 006.1-.86l-2.71-10.99-5.35.52 1.97 11.34z",
    fill: "#babac1",
    fillRule: "evenodd"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M338.54 279.46c-.17.42-1.08 2.81-1.08 2.9.34 11.13 20.98 20.11 46.38 20.11s46.38-9.13 46.38-20.39",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M383.79 290.04c22.88 0 41.54-8.72 41.54-19.41s-18.66-19.41-41.54-19.41-41.54 8.72-41.54 19.41 18.66 19.41 41.54 19.41zM342.51 268.44l-15.25 39.16",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1a18",
    strokeMiterlimit: 22.93,
    strokeWidth: 4,
    d: "M425.04 268.3l15.25 39.16"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5,
    d: "M307.06 345.21l11.5-6.64"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1a18",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5,
    d: "M427.95 275.41l12.81-7.4"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5,
    d: "M449 338.55l13.39 7.73M328.6 269.04l8.95 5.17M380.52 360.03v-9.24M278.31 307.58h14.01M475.21 307.58h15.83"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#babac1",
    fillRule: "evenodd",
    d: "M489.57 378.5l.3-18.84 11.09-6.37 2.17 13.14-13.56 12.07z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M491.04 310.96v123.97m0 68.96v60.46M491.23 337.81c4 4.69 7.29 10.79 9.24 17.75 4.54 16.17.29 31.38-9.5 35.96",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#45454d",
    fillRule: "evenodd",
    d: "M278.02 378.5l-.3-18.84-11.1-6.37-2.16 13.14 13.56 12.07z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M276.35 337.81c-4 4.69-7.29 10.79-9.24 17.75-4.54 16.17-.29 31.38 9.5 35.96M276.55 310.96V433.7m0 70v60.82",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M313.59 477.13c-.33-3.02-.92-6.12-1.8-9.26l-.05-.15 10.66-4.61c.91 3.26 1.53 6.56 1.9 9.83l-10.71 4.19zm1.42-30.83l-9.39 5.85 5.8 11.4 9.67-4.59c-.48-1.34-1-2.66-1.58-3.97-1.43-3.24-2.92-6.13-4.5-8.69z",
    fill: "#babac1",
    fillRule: "evenodd"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M282.26 428.26c.33-.08 1.28-.24 1.61-.3 15.2-2.64 32.36 13.04 38.7 35.62 5.16 18.4 1.6 35.83-7.88 43.93",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M276.24 436.32c13.73-3.13 29.53 10.97 35.29 31.49 5.76 20.52-.7 39.69-14.43 42.82-13.73 3.13-29.53-10.97-35.29-31.49-5.76-20.52.7-39.69 14.43-42.82zM270.63 438.71l18.51-19.23",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5,
    d: "M356.87 285.12l17.25-9.96M394.5 274.97l17.31 9.99M391.66 265.04l18-10.4M376.72 264.7l-17.08-9.86"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M335.44 371v22.89c-3.34-.74-6.59-1.56-9.72-2.45v-22.89c3.13.9 6.38 1.72 9.72 2.45zm-15.08 18.79c-3.4-1.12-6.65-2.34-9.72-3.64v-22.89c3.07 1.3 6.32 2.52 9.72 3.64v22.89zm-15.08-6.1c-3.54-1.74-6.78-3.61-9.72-5.59v-22.89c2.94 1.98 6.18 3.85 9.72 5.59v22.89z",
    fill: "#000003",
    fillRule: "evenodd"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4,
    d: "M297.1 510.63l27.05-4.71"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M439.11 592.29v-23.03c15.05-3.6 28.56-10.56 40.69-20.53.25 7.44.5 14.88.74 22.32-11.8 11.36-26.22 17.15-41.43 21.25z",
    fill: "#6d6f7a",
    fillRule: "evenodd"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M439.11 592.29v-23.03c9.65-2.31 18.67-6 27.1-10.98v23.43c-8.43 4.81-17.61 8.03-27.1 10.58z",
    fill: "#babac1",
    fillRule: "evenodd"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M479.81 571.75v-23.03c-9.09 8.57-23.23 15.7-40.69 20.53v23.03M479.81 560.24c-9.09 8.57-23.23 15.7-40.69 20.53",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M491.04 549.12c0 27.67-46.42 49.98-105.65 49.98s-108.84-22.63-108.84-50.3",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest2);
export default __webpack_public_path__ + "static/media/test2.f144726d5da2b7e5ad9cf37c3bcc866c.svg";
export { ForwardRef as ReactComponent };